import React, { Component, Fragment } from 'react'

class DetailSemester extends Component {
    constructor() {
        super()
        this.state = {
            listSemester: []
        }
    }

    componentDidMount() {

    }

    render() {

        const data = this.props.location.state ?? []

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p className="abu" style={{
                                fontSize: '15px', fontWeight: 'bold', color: '#999999',
                                textTransform: 'capitalize'
                            }}>
                                Detail Semester&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                            </p>
                        </div>
                    </div>
                </div>
                <div className="smooth">

                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: '25px', marginTop: '10px' }}></p>
                            <div className="table-responsive mt-3" id="">
                                <table id="" className="display expandable-table table-striped" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Semester</th>
                                            <th>Keterangan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data.map((list, i) => {
                                                return (
                                                    <tr >
                                                        <td>Semester {list.semester}</td>
                                                        <td>{list.status}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}
export default DetailSemester
